import ApiService from "@/services/api.service";

export default class ForestGameSettings {

    private static instance: ForestGameSettings;
    private apiService: ApiService = ApiService.getInstance();

    private constructor() {
    }

    public static getInstance(): ForestGameSettings {
        if (!ForestGameSettings.instance) {
            ForestGameSettings.instance = new ForestGameSettings();
        }
        return ForestGameSettings.instance;
    }

    public simulatorMode(): boolean {
        return this.apiService.forestGameSettings().simulatorMode;
    }

    public approachingRadius(): number {
        return this.apiService.forestGameSettings().approachingRadius;
    }

    public leavingRadius(): number {
        return this.apiService.forestGameSettings().leavingRadius;
    }
}